import type { TooltipOptions } from "primereact/tooltip/tooltipoptions";

import styles from "./action-tooltip.module.scss";

/**
 * Textos das tooltips da coluna "Ações" das listagens do Painel de Controle.
 * A ação de situação anuncia o que o clique faz, não o estado atual do registro:
 * registro ativo oferece "Desativar" e registro inativo oferece "Ativar".
 */
export const EDIT_ACTION_TOOLTIP = "Editar";
export const ACTIVATE_ACTION_TOOLTIP = "Ativar";
export const DEACTIVATE_ACTION_TOOLTIP = "Desativar";
export const DELETE_ACTION_TOOLTIP = "Excluir";
export const DETAIL_ACTION_TOOLTIP = "Detalhar";

/**
 * Ajuste visual único das tooltips das ações. A coluna "Ações" é a última da
 * tabela, por isso o texto é apresentado acima do ícone — à direita ele ficaria
 * fora da área visível nas telas mais estreitas.
 */
export const ACTION_TOOLTIP_OPTIONS: TooltipOptions = {
  position: "top",
  className: styles.actionTooltip,
  event: "both",
};

/** Rótulo da tooltip do ícone que alterna a situação de um registro. */
export function toggleActionTooltip(isActive: boolean): string {
  return isActive ? DEACTIVATE_ACTION_TOOLTIP : ACTIVATE_ACTION_TOOLTIP;
}
